import React from 'react'
import Form from './container'
import PageTemplate from 'components/page-template'

export default () => (
  <PageTemplate
    title='Create an Instagram Coupon Experience'
    description="that's where automagic happens"
    className='br-experience widgetBuilder'
  >
    <Form experiencePlatform='instagram' experienceType={'instagram_coupon'} />
  </PageTemplate>
)



// WEBPACK FOOTER //
// ./src/pages/widgets/instagram-coupon/create/index.js